module.exports = __webpack_public_path__ + "static/media/maf-21.8b7d7d22.png";